import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@features/auth/hooks/useAuth';
import { LoadingScreen } from './LoadingScreen';
import type { UserRole } from '@core/types/common.types';

interface ProtectedRouteProps {
  children?: React.ReactNode;
  allowedRoles?: UserRole[];
}

export function ProtectedRoute({ children, allowedRoles }: ProtectedRouteProps) {
  const { user, isLoading, isAuthenticated } = useAuth();
  const location = useLocation();

  // Show loading while checking authentication
  if (isLoading) {
    return <LoadingScreen />;
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check role-based access
  if (allowedRoles && user && !allowedRoles.includes(user.rol)) {
    // Redirect based on user role
    const redirectPath = 
      user.rol === 'cliente' ? '/portal/dashboard' :
      user.rol === 'tecnico' ? '/technician' :
      '/admin/dashboard';
    return <Navigate to={redirectPath} replace />;
  }

  return children ?? <Outlet />;
}

